$(() => {
  let elementClicked = null;
  let lastFocusedSearchType = '';

  function searchSubmit() {
    /* this is important in case if user push
         enter on keyboard to let know backend which
         type of search to perform */
    let lastFocused = $(this.id).context.activeElement;
    if ($(lastFocused).attr('name') === 'term' || $(lastFocused).attr('name') === 'hymn') {
      searchType = $(lastFocused).attr('name');
    } else if ($(lastFocused).attr('id') === 'next-page' || $(lastFocused).attr('id') === 'previous-page') {
      /* fix for double loading first page for term/hymn search */
      searchType = '';
    } else {
      lastFocused = elementClicked;
      searchType = (typeof lastFocused === 'undefined' || lastFocused == null) ? '' : $(lastFocused).attr('name');
    }

    if (searchType !== 'submit-term' && searchType !== 'submit-hymn') {
      switch (searchType) {
        case 'term-tmp':
        case 'term':
          searchType = 'submit-term';
          lastFocusedSearchType = 'submit-term';
          break;
        case 'hymnal':
        case 'hymn':
          searchType = 'submit-hymn';
          lastFocusedSearchType = 'submit-hymn';
          break;
        default:
          searchType = lastFocusedSearchType;
      }
    } else {
      lastFocusedSearchType = searchType;
    }

    if ($(this).find('input.hidden-type').length > 0) {
      $(this).find('input.hidden-type').val(lastFocusedSearchType);
    } else {
      const input = $('<input>')
          .attr('class', 'hidden-type')
          .attr('name', 'type')
          .attr('type', 'hidden')
          .val(lastFocusedSearchType);
      $(this).append(input);
    }

    if ($('input[name="term"]').length > 0) {
      $('input[name="term"]').val(encodeURIComponent($('input[name="term-tmp"]').val()));
    } else {
      const inputTerm = $('<input>')
          .attr('name', 'term')
          .attr('type', 'hidden')
          .val(encodeURIComponent($('input[name="term-tmp"]').val()));
      $(this).append(inputTerm);
    }

    $('input[name="term-tmp"]').attr('disabled', 'disabled');

    const downloadsOnly = $('#downloads-only').is(':checked');
    const downloadsInput = $('<input>')
        .attr('class', 'hidden-type')
        .attr('name', 'downloads-only')
        .attr('type', 'hidden')
        .val(downloadsOnly === true);
    $(this).append(downloadsInput);
  }

  if ($('input[name="term-tmp"]').length === 0) {
    $('input[name="term"]').attr('name', 'term-tmp');
  }

  $('input[name="term-tmp"]').removeAttr('disabled');

  document.addEventListener('click', (e) => {
    e = e || window.event;
    const target = e.target || e.srcElement;
    elementClicked = target;
  }, false);

  $('#searchForm').submit(searchSubmit);
});
$(() => {
  let elementClicked = null;
  let lastFocusedSearchType = '';

  function searchSubmit() {
    /* this is important in case if user push
         enter on keyboard to let know backend which
         type of search to perform */
    let lastFocused = $(this.id).context.activeElement;
    if ($(lastFocused).attr('name') === 'term' || $(lastFocused).attr('name') === 'hymn') {
      searchType = $(lastFocused).attr('name');
    } else if ($(lastFocused).attr('id') === 'next-page' || $(lastFocused).attr('id') === 'previous-page') {
      /* fix for double loading first page for term/hymn search */
      searchType = '';
    } else {
      lastFocused = elementClicked;
      searchType = (typeof lastFocused === 'undefined' || lastFocused == null) ? '' : $(lastFocused).attr('name');
    }

    if (searchType !== 'submit-term' && searchType !== 'submit-hymn') {
      switch (searchType) {
        case 'term-tmp':

        case 'term':
          searchType = 'submit-term';
          lastFocusedSearchType = 'submit-term';
          break;
        case 'hymnal':
        case 'hymn':
          searchType = 'submit-hymn';
          lastFocusedSearchType = 'submit-hymn';
          break;
        default:
          searchType = lastFocusedSearchType;
      }
    } else {
      lastFocusedSearchType = searchType;
    }

    if ($(this).find('input.hidden-type').length > 0) {
      $(this).find('input.hidden-type').val(lastFocusedSearchType);
    } else {
      const input = $('<input>')
          .attr('class', 'hidden-type')
          .attr('name', 'type')
          .attr('type', 'hidden')
          .val(lastFocusedSearchType);
      $(this).append(input);
    }

    if ($('input[name="term"]').length > 0) {
      $('input[name="term"]').val(encodeURIComponent($('input[name="term-tmp"]').val()));
    } else {
      const inputTerm = $('<input>')
          .attr('name', 'term')
          .attr('type', 'hidden')
          .val(encodeURIComponent($('input[name="term-tmp"]').val()));
      $(this).append(inputTerm);
    }

    $('input[name="term-tmp"]').attr('disabled', 'disabled');

    const downloadsOnly = $('#downloads-only').is(':checked');
    const downloadsInput = $('<input>')
        .attr('class', 'hidden-type')
        .attr('name', 'downloads-only')
        .attr('type', 'hidden')
        .val(downloadsOnly === true);
    $(this).append(downloadsInput);
  }

  if ($('input[name="term-tmp"]').length === 0) {
    $('input[name="term"]').attr('name', 'term-tmp');
  }

  $('input[name="term-tmp"]').removeAttr('disabled');

  document.addEventListener('click', (e) => {
    e = e || window.event;
    const target = e.target || e.srcElement;
    elementClicked = target;
  }, false);

  $('#searchForm').submit(searchSubmit);
});
